import { Component, Input, Output, EventEmitter, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router'

import { CurrencyService } from '../../shared/currency.service';
import { AnalyticsUtilsService } from '../../shared/analytics-utils.service';


declare var dataLayer: any;

@Component({
  selector: 'product-viewer',
  templateUrl: './product-viewer.component.html',
  styleUrls: ['./product-viewer.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ProductViewerComponent {
  @Input("item-limit") itemLimit: number;
  @Input("title") title: string;
  @Input("item-type") itemType: string;
  @Input("pageable") pageable: boolean;
  @Input("items") items: Object[];
  @Input("itemsSec") itemsSec: Object[];
  @Input("bg-color") bgColor: string = 'transparent';
  @Input("callback") callback: Function;
  @Output() onLoadMore: EventEmitter<any> = new EventEmitter();
  public listProduct: Object[];
  public isNode: boolean;


  constructor(public currencyService: CurrencyService, private router: Router,
    private r: ActivatedRoute, public analytics: AnalyticsUtilsService, @Inject(PLATFORM_ID) private platformId: string) {
    this.isNode = isPlatformServer(this.platformId)
  };

  loadMoreWasClicked(): void {
    this.onLoadMore.emit();
  }

  openProduct(item: Object) {
    this.analytics.eCommerce_productClick(item);
    this.router.navigate([this.transformUrl(item)], { relativeTo: this.r });
  }

  transformUrl(item: any): string {
    if (item.name == null) {
      return;
    }
    let language = item.textLanguage.locale.split("_")[0];
    let hrefLang = item.hreflangs[0];
    if (item.hreflangs.length > 1) {
      hrefLang = item.hreflangs.find(hl => {
        return hl.locale.split("_")[0] == language.split("_")[0];
      });
    }
    let locationId = hrefLang.locationId;
    let locationName = hrefLang.locationName;
    let name = hrefLang.url;
    return `/${language}/${locationId}/${locationName}/${item.id}/${name}`;
  }
}